import React, { useState } from "react";
import { hasPermission, CapSentenceArray } from "../utils/Utils.js";
import ModalInformation from "../modals/ModalInformation";
import { ModeloSearch } from "../ModeloCrud";
import crypto from "../Crypto";
import FacebookCircularProgress from "../FacebookCircularProgress";
import MultipleResultsTable from "../MultipleResultsTable";
import CustomizedSearch from "../CustomizedSearch.js";
import { useHistory } from "react-router-dom";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ProtectedRoute from "../ProtectedRoute";

// Columnas de la tabla de resultados cuando la búsqueda trae más de un nomenclador.
// "Ver" la agrega MultipleResultsTable solo, no va en objFields.
const objHeaders = ["Ver", "Código", "Descripción", "Habilitado"];
const objFields = ["codigo", "descripcion", "habilitado"];
const objDates = []; // nomenclador no tiene fechas en la tabla de listado

const LIMITE_RESULTADOS = 500;

const Nomencladores = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [searchNomenclador, setSearchNomenclador] = useState("");
  const [showAlert, setShowAlert] = useState(null);

  const [allNomenclador, setAllNomenclador] = useState(null);
  let [filterNomenclador, setFilterNomenclador] = useState(null);
  const [modalNomencladorOpen, setModalNomencladorOpen] = useState(false);

  const [modalMessage, setModalMessage] = useState(null);
  const [modalInformationOpen, setModalInformationOpen] = useState(false);
  const [modalErrorOpen, setModalErrorOpen] = useState(false);

  const userRoles =
    crypto.decryptLocalStorage("user_roles") !== null
      ? crypto.decryptLocalStorage("user_roles")
      : [];

  function onChangeSearchNomenclador(e) {
    setSearchNomenclador(e.target.value);
    if (modalNomencladorOpen) {
      FiltrarNomenclador(e.target.value);
    }
  }

  function busqueda() {
    buscarNomenclador(searchNomenclador, false);
  }

  function newNomenclador() {
    history.push({
      pathname: "/insertupdatenomenclador",
    });
  }

  function irAlForm(nomenclador) {
    history.push({
      pathname: "/insertupdatenomenclador",
      currentNomenclador: nomenclador,
    });
  }

  function FiltrarNomenclador(filtro) {
    if (filtro.length > 0) {
      filterNomenclador = allNomenclador.filter(
        (n) =>
          n.codigo.toLowerCase().indexOf(filtro.toLowerCase()) >= 0 ||
          n.descripcion.toLowerCase().indexOf(filtro.toLowerCase()) >= 0
      );
      if (filterNomenclador.length <= 0) {
        filterNomenclador = allNomenclador;
      }
    } else {
      filterNomenclador = allNomenclador;
    }
    setFilterNomenclador([...filterNomenclador]);
  }

  function limpiarBusqueda() {
    setShowAlert(null);
    setModalNomencladorOpen(false);
    setAllNomenclador(null);
    setFilterNomenclador(null);
    setLoading(false);
  }

  const hideInformationModal = () => {
    setModalMessage(null);
    setModalInformationOpen(false);
  };
  const hideErrorModal = () => {
    setModalMessage(null);
    setModalErrorOpen(false);
  };

  // Busqueda contra el endpoint genérico postBuscar: POST {recurso}/buscar
  // con columna=>valor + tipo_busqueda ('and'/'or') + comparacion_busqueda
  // ('exacto'/'like'/'likefull'/'in').
  async function buscarNomenclador(valor, isId) {
    limpiarBusqueda();

    if (!isId && (typeof valor !== "string" || valor.trim().length < 3)) {
      setShowAlert("Ingrese al menos 3 caracteres !");
      return;
    }

    const Data = isId
      ? {
          id: valor,
          tipo_busqueda: "and",
          comparacion_busqueda: "exacto",
        }
      : {
          codigo: valor,
          descripcion: valor,
          tipo_busqueda: "or",
          comparacion_busqueda: "likefull",
        };

    setLoading(true);
    let result = await ModeloSearch("nomenclador", Data);
    setLoading(false);

    if (result.error === true) {
      setModalMessage(result.mensaje || result.errormessage || "Ocurrió un error.");
      setModalErrorOpen(true);
      return;
    }

    const listado = result.listado || [];

    if (listado.length === 0) {
      setModalMessage("No se encontraron registros.");
      setModalInformationOpen(true);
    } else if (listado.length === 1) {
      // Un solo resultado: directo al form
      irAlForm(listado[0]);
    } else if (listado.length > LIMITE_RESULTADOS) {
      setModalMessage(
        "Demasiados resultados(" +
          listado.length.toString() +
          ") refine la búsqueda."
      );
      setModalInformationOpen(true);
    } else {
      setAllNomenclador(listado);
      setFilterNomenclador(listado);
      setModalNomencladorOpen(true);
    }
  }

  return (
    <ProtectedRoute
      userRoles={userRoles}
      requiredPermission={"VISUALIZAR NOMENCLADOR"}
    >
      <div className="flex justify-center mt-4 ml-2 mr-3">
        <CustomizedSearch
          value={searchNomenclador}
          onchange={onChangeSearchNomenclador}
          handlebusqueda={busqueda}
          placeholder="Código, Descripción..."
          width={{ xs: 400, md: 500 }}
          starticon={
            hasPermission(userRoles, "ALTA NOMENCLADOR") ? (
              <AddRoundedIcon sx={{ fontSize: 48, color: "icongreen" }} />
            ) : null
          }
          handlestart={
            hasPermission(userRoles, "ALTA NOMENCLADOR") ? newNomenclador : null
          }
        />
      </div>

      <div className="flex justify-center mt-2">
        {loading && <FacebookCircularProgress />}
      </div>

      {modalNomencladorOpen && filterNomenclador.length > 0 && (
        <MultipleResultsTable
          setShowModal={setModalNomencladorOpen}
          pallData={CapSentenceArray(filterNomenclador, ["descripcion"])}
          objFields={objFields}
          objHeaders={objHeaders}
          objDates={objDates}
          selectedMethod={(id) => buscarNomenclador(id, true)}
          highlightText={searchNomenclador}
        />
      )}

      {showAlert !== null && (
        <div className="flex items-center justify-center mt-5 ml-12">
          {showAlert}
        </div>
      )}

      <ModalInformation
        showModal={modalInformationOpen && modalMessage !== null}
        hideModal={hideInformationModal}
        message={modalMessage}
      />
      <ModalInformation
        showModal={modalErrorOpen && modalMessage !== null}
        hideModal={hideErrorModal}
        message={modalMessage}
        tipo="error"
      />
    </ProtectedRoute>
  );
};

export default Nomencladores;
